import VueRouter, { RawLocation, RouteRecord } from "vue-router";

// Roles a route record declares in meta.role, if any.
function declaredRoles(record: RouteRecord): string[] | undefined {
  const role = record.meta?.role;
  return Array.isArray(role) ? role : undefined;
}

// Every matched record that declares roles must allow the user: a child
// route can narrow its parent's roles (e.g. the FULL_ADMIN pages under
// /admin), and a child without roles keeps its parent's.
export function rolesAllow(matched: RouteRecord[], role?: string): boolean {
  const lists = matched.map(declaredRoles).filter((l): l is string[] => !!l);
  if (!lists.length) return false;
  return lists.every(
    (list) => list.includes("anyone") || (!!role && list.includes(role))
  );
}

// Whether the route opens without logging in: every record is noAuth or
// open to anyone (records without roles follow the others).
export function openToAnyone(matched: RouteRecord[]): boolean {
  const open = (record: RouteRecord) =>
    !!record.meta?.noAuth || !!declaredRoles(record)?.includes("anyone");
  return (
    matched.some(open) &&
    matched.every((record) => open(record) || !declaredRoles(record))
  );
}

// For links and buttons: whether a user with this role may open the
// location (same rule as the navigation guard), so the UI can hide it.
export function canOpen(
  router: VueRouter,
  location: RawLocation,
  role?: string
): boolean {
  return rolesAllow(router.resolve(location).route.matched, role);
}
